import styled from '@emotion/styled';

import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import CaretV2Icon from '@zola/zola-ui/src/components/SvgIcons/CaretV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const List = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin: ${SPACING.SM} 0 ${SPACING.MD};
  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledLinkV2 = styled(LinkV2)`
  display: flex;
  align-items: center;
`;

export const ListItem = styled.li`
  &:not(:last-of-type) {
    margin-bottom: ${SPACING.SM};
  }
`;

export const Title = styled.span`
  padding-left: ${SPACING.XS};
`;

export const ChildrenList = styled.ul`
  list-style-type: none;
  margin-top: ${SPACING.SM};
  padding-left: ${SPACING.S32};
`;

export const StyledCaretIcon = styled(CaretV2Icon)`
  margin-left: auto;
  transition: transform 0.2s ease 0s;
`;
